function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { useEffect, useState } from "react";
import UIModal from "./ui/UIModal";
import { injectIntl } from "react-intl";
// Prompts user to rotate their device to landscape mode if currently in portrait mode.
// Uses the standard UIModal component and should be styled via theme.
var portrait = window.matchMedia("(orientation: portrait)");
var RotateDevicePrompt = function(param) {
    var intl = param.intl;
    var _useState = _slicedToArray(useState(false), 2), isVisible = _useState[0], setIsVisible = _useState[1];
    var watchOrientationChange = function(e) {
        if ("ontouchstart" in document.documentElement && e.matches) {
            // Portrait mode and on mobile device
            setIsVisible(true);
        } else {
            // Landscape
            setIsVisible(false);
        }
    };
    useEffect(function() {
        if ("ontouchstart" in document.documentElement && portrait.matches) {
            setIsVisible(true);
        }
        portrait.addEventListener("change", watchOrientationChange);
        return function() {
            portrait.removeEventListener("change", watchOrientationChange);
        };
    }, []);
    return /*#__PURE__*/ React.createElement(UIModal, {
        isVisible: isVisible,
        title: intl.formatMessage({
            id: "ui.rotate_device.header",
            defaultMessage: "Rotate your device!"
        }),
        onClose: function() {
            return setIsVisible(false);
        }
    }, /*#__PURE__*/ React.createElement("p", null, intl.formatMessage({
        id: "ui.rotate_device.content",
        defaultMessage: "This content is optimized for landscape mode. Rotate your device to continue."
    })));
};
export default injectIntl(RotateDevicePrompt);
